import { action, computed, observable, toJS } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    Enums,
    FormStore,
    getValueFromOption,
    inject,
    isNotArray,
    toArray,
    uuidv4generate,
} from 'Mri.Web.Common';
import * as React from 'react';
import Select from 'react-select';
import { ValueType } from 'react-select/src/types';
import { DropdownItem, DropdownMenu, DropdownToggle, Input, UncontrolledButtonDropdown } from 'reactstrap';
import { AlertActionsStore } from './AlertActionsStore';

interface IOption {
    label: string;
    value: string;
}

export interface IAddRecipientItemProps {
    onChange(recipient: Mri.DisplayAlerts.ActionRecipient): any;
    readonly disabled?: boolean;
    readonly alertActionForm: FormStore<Mri.DisplayAlerts.AlertAction>;
    readonly internal: boolean;
}

@autoinject
@observer
export class AddRecipientItem extends React.Component<IAddRecipientItemProps> {
    public render() {
        return (
            <div className="d-flex">
                <UncontrolledButtonDropdown className="d-block" disabled={this.props.disabled}>
                    <DropdownToggle caret color="primary">
                        {Enums.toString(Enums.RecipientType, this.newRecipient.type)}
                    </DropdownToggle>

                    <DropdownMenu>
                        <DropdownItem onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.Email)}>
                            {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.Email)}
                        </DropdownItem>

                        <DropdownItem onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.SMS)}>
                            {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.SMS)}
                        </DropdownItem>

                        <DropdownItem
                            onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.WarrantyEmail)}
                        >
                            {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.WarrantyEmail)}
                        </DropdownItem>
                        {/*
                        <DropdownItem onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.Ticket)}>
                            {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.Ticket)}
                        </DropdownItem>
                        */}

                        <DropdownItem
                            onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.AccountSubscribers)}
                        >
                            {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.AccountSubscribers)}
                        </DropdownItem>

                        <DropdownItem
                            onClick={e =>
                                this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.OutOfWarrantySubscribers)
                            }
                        >
                            {Enums.toString(
                                Enums.RecipientType,
                                Mri.DisplayAlerts.RecipientType.OutOfWarrantySubscribers
                            )}
                        </DropdownItem>

                        {
                            //<DropdownItem onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.UserId)}>
                            //    {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.UserId)}
                            //</DropdownItem>
                            //<DropdownItem onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.Ticket)}>
                            //    {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.Ticket)}
                            //</DropdownItem>
                            //<DropdownItem onClick={e => this.setRecipientType(e, Mri.DisplayAlerts.RecipientType.Webhook)}>
                            //    {Enums.toString(Enums.RecipientType, Mri.DisplayAlerts.RecipientType.Webhook)}
                            //</DropdownItem>
                        }
                    </DropdownMenu>
                </UncontrolledButtonDropdown>

                {(this.newRecipient.type == Mri.DisplayAlerts.RecipientType.UserId ||
                    this.newRecipient.type == Mri.DisplayAlerts.RecipientType.Email ||
                    this.newRecipient.type == Mri.DisplayAlerts.RecipientType.WarrantyEmail ||
                    this.newRecipient.type == Mri.DisplayAlerts.RecipientType.SMS) && (
                    <>
                        <div className="flex-fill ms-3">
                            <Select
                                isDisabled={this.props.disabled}
                                classNamePrefix="react-select"
                                options={this.usersOptions}
                                onChange={this.selectUser}
                            />
                        </div>

                        <button
                            className="btn btn-primary ms-3"
                            onClick={this.addRecipient}
                            disabled={!this.newRecipient.value.length || this.props.disabled}
                        >
                            Add Recipient
                        </button>
                    </>
                )}

                {this.newRecipient.type == Mri.DisplayAlerts.RecipientType.Ticket && (
                    <div className="flex-fill ms-3">
                        <button
                            className="btn btn-primary ms-3"
                            onClick={this.addRecipient}
                            disabled={this.props.disabled}
                        >
                            Add Ticket Sync
                        </button>
                    </div>
                )}

                {this.newRecipient.type == Mri.DisplayAlerts.RecipientType.Webhook && (
                    <>
                        <div className="flex-fill ms-3">
                            <Input onChange={this.selectValue} />

                            <button
                                className="btn btn-primary ms-3"
                                onClick={this.addRecipient}
                                disabled={this.props.disabled}
                            >
                                Add WebHook
                            </button>
                        </div>
                    </>
                )}

                {this.newRecipient.type == Mri.DisplayAlerts.RecipientType.AccountSubscribers && (
                    <div className="flex-fill ms-3">
                        <button
                            className="btn btn-primary ms-3"
                            onClick={this.addRecipient}
                            disabled={this.props.disabled}
                        >
                            Add Warranty Alert For All Subscribers
                        </button>
                    </div>
                )}

                {this.newRecipient.type == Mri.DisplayAlerts.RecipientType.OutOfWarrantySubscribers && (
                    <div className="flex-fill ms-3">
                        <button
                            className="btn btn-primary ms-3"
                            onClick={this.addRecipient}
                            disabled={this.props.disabled}
                        >
                            Add Out Of Warranty Alert For All Subscribers
                        </button>
                    </div>
                )}
            </div>
        );
    }

    @bind
    @action
    private setRecipientType(e: React.MouseEvent, recipientType: Mri.DisplayAlerts.RecipientType) {
        e.preventDefault();

        this.newRecipient.type = recipientType;
    }

    @computed
    private get usersOptions() {
        return toArray(this.alertActionsStore.recipients)
            .filter(r => r.internalUser == this.props.internal)
            .map(r => {
                return {
                    value: r.id,
                    label: r.email,
                };
            });
    }

    @bind
    @action
    private selectUser(value: ValueType<IOption, boolean>) {
        const selectedValue = getValueFromOption(value);

        if (selectedValue && isNotArray(selectedValue)) {
            this.newRecipient.value = selectedValue;
        }
    }

    @bind
    @action
    private selectValue(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;

        this.newRecipient.value = target.value;
    }

    @bind
    @action
    private addRecipient(e: React.FormEvent) {
        e.preventDefault();

        this.props.onChange(toJS(this.newRecipient)); // Send copy of object
    }

    @observable
    private newRecipient: Mri.DisplayAlerts.ActionRecipient = {
        type: Mri.DisplayAlerts.RecipientType.Email,
        value: '',
    };
    @inject
    private alertActionsStore!: AlertActionsStore;
}
